// konfigurator-cart-bridge.js
// Nimmt die "In den Warenkorb legen"-Nachricht vom eingebetteten Konfigurator entgegen und legt
// die Artikel in den normalen Shop-Warenkorb.
//
// ARCHITEKTUR (nach mehreren Anläufen): /cart/update.js SETZT die Menge pro Artikel auf einen
// exakten, absoluten Wert statt sie zu addieren - unempfindlich gegen Mehrfachauslösung an sich.
// Shopifys eigenes "shop_events_listener"-System kann die Warenkorb-Aktion jedoch unabhängig und
// ZEITLICH VERZöGERT (auch nach einem Seitenwechsel) noch einmal beeinflussen. Deshalb wird der
// Ziel-Warenkorbinhalt in localStorage gemerkt (übersteht Seitenwechsel) und ueber mehrere
// Sekunden UND bei jedem folgenden Seitenaufruf erneut exakt gesetzt ("reasserted"), bis er
// mehrfach in Folge stabil bleibt. Da update.js SETZT statt addiert, ist wiederholtes Setzen
// desselben Zielwerts immer unschaedlich - das schliesst eine Verdopplung zuverlässig aus.
//
// Navigations-Schutz: siehe frühere Kommentare - fängt Seiten-Navigation für 8 Sekunden ab.
// Scroll-Hilfe & Warenkorb-Stand/Leeren: siehe frühere Kommentare.
(function () {
  var TARGET_KEY = 'hd_cart_target';

  function beforeUnloadGuard(e) {
    e.preventDefault();
    e.returnValue = '';
    return '';
  }

  function armNavigationGuard() {
    window.addEventListener('beforeunload', beforeUnloadGuard);
    setTimeout(function () {
      window.removeEventListener('beforeunload', beforeUnloadGuard);
    }, 8000);
  }

  function updateCartCountBadge(count) {
    document.querySelectorAll('.js-cart-count').forEach(function (el) { el.textContent = count; });
  }

  function replyToIframe(data) {
    var iframes = document.querySelectorAll('iframe[src*="konfiguratorv1.haustechnikdirekt.de"]');
    iframes.forEach(function (f) {
      if (f.contentWindow) f.contentWindow.postMessage(data, '*');
    });
  }

  function setExactQuantities(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) { if (!res.ok) throw new Error('Warenkorb-Fehler'); return res.json(); });
  }

  // Setzt den gemerkten Ziel-Warenkorbinhalt erneut exakt, mehrfach ueber mehrere Sekunden verteilt
  // (auch nach Seitenwechsel, dank localStorage). Raeumt den Merker auf, sobald genug Runden
  // gemacht wurden oder er zu alt ist (> 90 Sekunden).
  function reassertTarget(roundsLeft) {
    var raw = localStorage.getItem(TARGET_KEY);
    if (!raw) return;
    var target;
    try { target = JSON.parse(raw); } catch (e) { localStorage.removeItem(TARGET_KEY); return; }
    if (!target || !target.updates || (Date.now() - target.timestamp) > 90000) {
      localStorage.removeItem(TARGET_KEY);
      return;
    }
    setExactQuantities(target.updates).then(function (cart) {
      updateCartCountBadge(cart.item_count);
      if (roundsLeft > 0) {
        setTimeout(function () { reassertTarget(roundsLeft - 1); }, 1500);
      } else {
        localStorage.removeItem(TARGET_KEY);
      }
    }).catch(function () {
      if (roundsLeft > 0) setTimeout(function () { reassertTarget(roundsLeft - 1); }, 1500);
    });
  }

  // Bei JEDEM Seitenaufruf pruefen, ob noch ein offener Zielwert ansteht (z.B. weil die vorherige
  // Seite durch eine Weiterleitung verlassen wurde, bevor alle Runden durch waren).
  reassertTarget(6);

  window.addEventListener('message', function (event) {
    if (!event.data || event.origin.indexOf('konfiguratorv1.haustechnikdirekt.de') === -1) return;

    if (event.data.type === 'hd-scroll-to-configurator') {
      var iframes = document.querySelectorAll('iframe[src*="konfiguratorv1.haustechnikdirekt.de"]');
      iframes.forEach(function (f) { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      return;
    }

    if (event.data.type === 'hd-get-cart-count') {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateCartCountBadge(cart.item_count);
        replyToIframe({ type: 'hd-cart-count', count: cart.item_count });
      }).catch(function () {});
      return;
    }

    if (event.data.type === 'hd-clear-cart') {
      localStorage.removeItem(TARGET_KEY);
      fetch('/cart/clear.js', { method: 'POST' }).then(function (r) { return r.json(); }).then(function (cart) {
        updateCartCountBadge(cart.item_count || 0);
        replyToIframe({ type: 'hd-cart-cleared' });
      }).catch(function () {});
      return;
    }

    if (event.data.type !== 'hd-add-to-cart' || !Array.isArray(event.data.lines)) return;
    var items = event.data.lines
      .filter(function (l) { return l && l.variantId && l.quantity > 0; })
      .map(function (l) { return { id: parseInt(l.variantId, 10), quantity: l.quantity }; });
    if (!items.length) return;

    armNavigationGuard();

    var updates = {};
    items.forEach(function (item) { updates[item.id] = item.quantity; });

    // Zielwert dauerhaft merken (uebersteht Seitenwechsel) UND sofort setzen.
    localStorage.setItem(TARGET_KEY, JSON.stringify({ updates: updates, timestamp: Date.now() }));

    setExactQuantities(updates)
      .then(function (cart) {
        updateCartCountBadge(cart.item_count);
        setTimeout(function () { reassertTarget(6); }, 1000);
      })
      .catch(function (err) {
        console.error('Fehler beim Hinzufuegen zum Warenkorb:', err);
        alert('Die Artikel konnten nicht automatisch in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.');
      });
  });
})();
